
import { Component, Vue } from "vue-property-decorator";

@Component
export default class AButton extends Vue {
  get commonAttrs() {
    const isLarge = "large" in this.$attrs && (this.$attrs.large as any) !== false;
    const isSmall = "small" in this.$attrs && (this.$attrs.small as any) !== false;

    return {
      class: ["a-button", isLarge ? "--large" : "", isSmall ? "--small" : ""],
      ...this.$props,
    };
  }
}
